/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
// Skip tslint any type check cause this method is aiming to check type of
// input.
// tslint:disable-next-line:no-any
export function isLocalPath(source) {
    return (typeof source === 'string') && source.substr(0, 7) === 'file://';
}
//# sourceMappingURL=source_util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-data/dist/util/source_util.js
// module id = 587
// module chunks = 0